import React, { useState } from 'react'
import MicroModal from 'micromodal'
import Modal from '../../common/modal/Modal'
import { performRequest } from '../../common/utils'
import ResponseMessage from '../../common/modal/ResponseMessage'

const GroupUnlink = ({ groupDetails }) => {
  const [ isRequesting, setIsRequesting ] = useState( false )
  const [ responseMessage, setResponseMessage ] = useState()
  
  MicroModal.init()

  const openModal = () => {
    MicroModal.show('msync-group-unlink-modal')
  }

  const handleUnlink = async() => {
    const formData = new FormData()
    formData.append('action', 'msync_unlink_group_from_team')
    formData.append('group_id', groupDetails?.ID)
    formData.append('team_id', groupDetails?.team_id)

    try {
      setIsRequesting( true )

      const request = await performRequest(msyncCsvImport.url, formData)
       
      const res = await request.json()

      if( !res.success ){
          throw new Error(res.message)
      }

      setResponseMessage({
        type: 'success',
        message: res.message
      })

      location.assign( msyncCsvImport.current_url )
    } catch (error) {
      setResponseMessage({
        type:'error',
        message: `${error}`
      })
    } finally {
      setIsRequesting( false )
    }
  }

  return (
    <>
      <div className='msync-team-group-link-unlink'>
        <a href={groupDetails?.edit_post_link} target="_blank" className='msync-team-group-link-unlink__link'>{groupDetails?.post_title}</a>
        <button type='button' className='msync-button msync-outline-primary-button' onClick={openModal}>Unlink</button>
      </div>

      <Modal modalId="msync-group-unlink-modal" buttonTitle="">
        <header className="modal__header">
            <h2 className="modal__title">Unlink Synced LearnDash Group</h2>
            <button type='button' className="modal__close" aria-label="Close modal" onClick={()=>MicroModal.close('msync-group-unlink-modal')}></button>
        </header>
        <main className="modal__content">
          { responseMessage && <ResponseMessage response={ responseMessage } /> }
          <p>
            <strong>WARNING: this action is irreversible!</strong><br />
            Are you sure you want to unlink this LearnDash group from the synced WooCommerce team?
            You will have to create a new team-synced group for this team if you want to restore this
            functionality.
          </p>
        </main>
        <footer className="modal__footer">
          <button className="msync-button msync-button-md primary-color" data-micromodal-close aria-label="Close this dialog window">Cancel</button>
          <button type='button' className="msync-button msync-button-md msync-outline-error-button" onClick={handleUnlink} disabled={isRequesting}>
            { isRequesting ? 'Unlinking...' : 'Unlink Group' }
          </button>
        </footer>
      </Modal>
    </>
  )
}

export default GroupUnlink